/* global EXCLUDED_HANDLES — injected from liquid */

let allProducts = [];
let cajaSize = 6;
let slots = [];

// ============================================================
// INIT
// ============================================================
document.addEventListener('DOMContentLoaded', loadProducts);

async function loadProducts() {
  try {
    const res = await fetch('/products.json?limit=250');
    const data = await res.json();

    allProducts = data.products
      .filter(p => !EXCLUDED_HANDLES.includes(p.handle.toLowerCase()))
      .filter(p => p.variants && p.variants[0])
      .filter(p => p.variants[0].available)
      .map(p => ({
        id: p.id,
        title: p.title,
        handle: p.handle,
        price: p.variants[0].price,
        variant_id: p.variants[0].id,
        image: p.images[0] ? p.images[0].src : null
      }));

    setCajaSize(6);
  } catch (e) {
    console.error('Error cargando productos:', e);
  }
}

// ============================================================
// CAJA SIZE
// ============================================================
function setCajaSize(size) {
  cajaSize = size;
  slots = randomProducts(size);

  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.classList.toggle('active', parseInt(btn.dataset.size) === size);
  });

  const grid = document.getElementById('slots-grid');
  grid.className = 'slots-grid cols-' + size;
  document.getElementById('total-count').textContent = size;

  renderSlots();
  updateProgress();
}

// ============================================================
// RANDOM DEFAULT
// ============================================================
function randomProducts(n) {
  const shuffled = [...allProducts].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, n).map(p => p.variant_id);
}

// ============================================================
// RENDER
// ============================================================
function renderSlots() {
  const grid = document.getElementById('slots-grid');
  grid.innerHTML = '';

  for (let i = 0; i < cajaSize; i++) {
    const variantId = slots[i];
    const product = variantId ? allProducts.find(p => p.variant_id == variantId) : null;

    const card = document.createElement('div');
    card.className = 'slot-card' + (product ? ' filled' : '');

    card.innerHTML = `
      <span class="slot-num">${String(i + 1).padStart(2, '0')}</span>
      <button class="slot-remove" onclick="clearSlot(${i})" title="Quitar">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
      <div class="slot-img-wrap">
        ${product && product.image
          ? `<img src="${product.image}" alt="${product.title}" loading="lazy">`
          : `<div class="slot-empty-icon">
              <svg width="28" height="40" viewBox="0 0 28 40" fill="none">
                <rect x="8" y="0" width="12" height="6" rx="2" stroke="currentColor" stroke-width="1.2"/>
                <rect x="4" y="6" width="20" height="32" rx="3" stroke="currentColor" stroke-width="1.2"/>
                <line x1="4" y1="14" x2="24" y2="14" stroke="currentColor" stroke-width="1"/>
              </svg>
              <span>Elegir</span>
            </div>`
        }
      </div>
      <div class="slot-info">
        <div class="slot-name">${product ? product.title : ''}</div>
        ${product ? `<div class="slot-price">${formatPrice(product.price)}</div>` : ''}
      </div>
      <select class="slot-select" onchange="selectWine(${i}, this.value)">
        <option value="">— Seleccioná un vino —</option>
        ${allProducts.map(p => `
          <option value="${p.variant_id}" ${variantId == p.variant_id ? 'selected' : ''}>
            ${p.title} · ${formatPrice(p.price)}
          </option>
        `).join('')}
      </select>
    `;

    grid.appendChild(card);
  }
}

// ============================================================
// SLOT ACTIONS
// ============================================================
function selectWine(index, variantId) {
  slots[index] = variantId || null;
  renderSlots();
  updateProgress();
}

function clearSlot(index) {
  slots[index] = null;
  renderSlots();
  updateProgress();
}

// ============================================================
// PROGRESS + TOTAL
// ============================================================
function updateProgress() {
  const filled = slots.filter(Boolean).length;

  document.getElementById('filled-count').textContent = filled;
  document.getElementById('progress-fill').style.width = (filled / cajaSize * 100) + '%';

  let total = 0;
  slots.forEach(vid => {
    if (vid) {
      const p = allProducts.find(pr => pr.variant_id == vid);
      if (p) total += parseFloat(p.price);
    }
  });
  document.getElementById('total-display').textContent = formatPrice(total.toFixed(2));

  const btn = document.getElementById('btn-cart');
  if (filled === cajaSize) {
    btn.disabled = false;
    btn.textContent = 'Agregar al carrito';
  } else {
    btn.disabled = true;
    btn.textContent = `Faltan ${cajaSize - filled} vinos`;
  }
}

// ============================================================
// ADD TO CART
// ============================================================
async function addCajaToCart() {
  if (slots.some(s => !s)) return;

  const btn = document.getElementById('btn-cart');
  const msg = document.getElementById('cart-msg');

  btn.disabled = true;
  btn.textContent = 'Agregando...';
  msg.textContent = '';
  msg.className = 'cart-msg';

  try {
    for (const vid of slots) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1, properties: { '_caja_vinos': 'true' } }] })
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Error');
      }
    }
    msg.textContent = '¡Caja agregada! Redirigiendo...';
    msg.className = 'cart-msg success';
    setTimeout(() => window.location.href = '/cart', 1200);
  } catch(e) {
    msg.textContent = e.message;
    msg.className = 'cart-msg error';
    btn.disabled = false;
    btn.textContent = 'Agregar al carrito';
  }
}

// ============================================================
// HELPERS
// ============================================================
function formatPrice(price) {
  return '$' + parseFloat(price).toLocaleString('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
}